export default "__VITE_ASSET__BofOJlsY__"